import { PaperGradientBG } from "../kits";

export default function Impressum() {
  return (
    <PaperGradientBG variant="zenBlack">
      <div className="min-h-screen flex items-start justify-center px-4 py-20">
        <div className="w-full max-w-2xl">

          {/* Terminal: impressum */}
          <div className="border border-[#AC8E66]/20 rounded-lg overflow-hidden">
            {/* Title bar */}
            <div className="flex items-center gap-2 px-4 py-2 bg-[#1a1a1a]">
              <span className="w-3 h-3 rounded-full bg-[#ff5f57]" />
              <span className="w-3 h-3 rounded-full bg-[#febc2e]" />
              <span className="w-3 h-3 rounded-full bg-[#28c840]" />
              <span className="ml-3 text-[#EFEBDC]/40 text-xs font-mono">impressum</span>
            </div>

            {/* Terminal body */}
            <div className="p-6 sm:p-8 space-y-6 font-mono text-xs">

              {/* Command */}
              <div>
                <span className="text-[#AC8E66]">$</span>
                <span className="text-[#EFEBDC]/90 ml-2">legal --info</span>
              </div>

              {/* Angaben gemäß § 5 TMG */}
              <div className="space-y-1">
                <p className="text-[#AC8E66]/80 text-[10px] uppercase tracking-widest">angaben gemaess § 5 tmg</p>
                <p className="text-[#EFEBDC]/70 leading-relaxed">
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>Denis Bitter<br />
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>Ferdinandstrasse 15<br />
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>20095 Hamburg<br />
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>Deutschland
                </p>
              </div>

              {/* Kontakt */}
              <div className="space-y-1">
                <p className="text-[#AC8E66]/80 text-[10px] uppercase tracking-widest">kontakt</p>
                <p className="text-[#EFEBDC]/70">
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                  e-mail:{" "}
                  <a
                    href="mailto:saghallo@denisbitter.de"
                    className="text-[#AC8E66] hover:text-[#AC8E66]/80 transition-colors"
                  >
                    saghallo@denisbitter.de
                  </a>
                </p>
              </div>

              {/* Verantwortlich */}
              <div className="space-y-1">
                <p className="text-[#AC8E66]/80 text-[10px] uppercase tracking-widest">verantwortlich § 55 abs. 2 rstv</p>
                <p className="text-[#EFEBDC]/70 leading-relaxed">
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>Denis Bitter<br />
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>Ferdinandstrasse 15<br />
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>20095 Hamburg<br />
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>Deutschland
                </p>
              </div>

              {/* Haftungsausschluss */}
              <div className="space-y-1">
                <p className="text-[#AC8E66]/80 text-[10px] uppercase tracking-widest">haftungsausschluss</p>
                <p className="text-[#EFEBDC]/70 leading-relaxed">
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                  Trotz sorgfaeltiger inhaltlicher Kontrolle uebernehme ich keine Haftung fuer externe Links. Fuer den Inhalt der verlinkten Seiten sind ausschliesslich deren Betreiber verantwortlich.
                </p>
              </div>

              {/* Urheberrecht */}
              <div className="space-y-1">
                <p className="text-[#AC8E66]/80 text-[10px] uppercase tracking-widest">urheberrecht</p>
                <p className="text-[#EFEBDC]/70 leading-relaxed">
                  <span className="text-[#AC8E66]/80 mr-2">&gt;</span>
                  Alle Inhalte dieser Website (Texte, Grafiken, Bilder, Videos) unterliegen dem deutschen Urheberrecht. Die Vervielfaeltigung, Bearbeitung oder Verbreitung ist ohne ausdrueckliche Zustimmung nicht gestattet.
                </p>
              </div>

              {/* Stand */}
              <p className="text-green-400/70 text-[10px] pt-2">
                # stand: mai 2025
              </p>

            </div>
          </div>

        </div>
      </div>
    </PaperGradientBG>
  );
}
